import { Message } from 'element-ui';
export function showMessage (showClose, message, type) {
    Message({
        showClose: showClose,
        message: message,
        type: type
    });
}
export default {
    showMessage
}